const isMac = () => navigator.platform.toUpperCase().indexOf('MAC') >= 0

export default isMac
